import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import config from '../../../../../config'
import { useTranslation } from '@/hooks/useTranslation'

export const OverviewSection = () => {
	const { t } = useTranslation()
	
	return (
		<section id="overview" className="mb-16">
			<h1 className="text-4xl font-bold tracking-tight text-gray-900 dark:text-gray-100 mb-4">
				{t('docs.overview.title')}
			</h1>
			<p className="text-xl text-gray-600 dark:text-gray-400 mb-8">
				{t('docs.overview.description', { appName: config.appName })}
			</p>

			<div className="grid md:grid-cols-2 lg:grid-cols-2 gap-6 mb-8">
				<Card className="shadow-sm dark:bg-gray-800/50">
					<CardHeader>
						<CardTitle className="text-lg flex items-center gap-2">
							⚡ {t('docs.overview.quickStart.title')}
						</CardTitle>
					</CardHeader>
					<CardContent>
						<p className="text-sm text-gray-600 dark:text-gray-400">
							{t('docs.overview.quickStart.description')}
						</p>
					</CardContent>
				</Card>
				<Card className="shadow-sm dark:bg-gray-800/50">
					<CardHeader>
						<CardTitle className="text-lg flex items-center gap-2">
							🚀 {t('docs.overview.frameworkSupport.title')}
						</CardTitle>
					</CardHeader>
					<CardContent>
						<p className="text-sm text-gray-600 dark:text-gray-400">
							{t('docs.overview.frameworkSupport.description')}
						</p>
					</CardContent>
				</Card>
			</div>
		</section>
	)
}